// extracted by mini-css-extract-plugin
module.exports = {"container":"MainPageCharts_container__jB0x_","row":"MainPageCharts_row__TbGhR","title":"MainPageCharts_title__pOqpy"};